module.exports = __webpack_public_path__ + "img/1.139a4e22.jpg";